export default {
    allFaceStatus: 'สถานะรูปใบหน้าทั้งหมด',
    validFaceImage: 'มีรูป',
    inValidFaceImage: 'ไม่มีรูป',
    searchText: 'ค้นหาจากชื่อ, รหัสพนักงาน',
    search: 'ค้นหา',
    employeeId: 'รหัส',
    employeeName: 'ชื่อ',
    prefixThai: 'คำนำหน้าไทย',
    prefixEnglish: 'คำนำหน้าอังกฤษ',
    firstNameThai: 'ชื่อไทย',
    firstNameEnglish: 'ชื่ออังกฤษ',
    lastNameThai: 'นามสกุลไทย',
    lastNameEnglish: 'นามสกุลอังกฤษ',
    bureauAcronym: 'ชื่อย่อสำนักงาน',
    positionAcronym: 'ชื่อย่อตำแหน่ง',
    status: 'สถานะ',
    line: 'ไลน์',
    hasFace: 'ใบหน้า',
    importFaceImage: 'นำเข้าพนักงาน',
    employeeManagement: 'บริหารจัดการพนักงาน',
    action: 'ปุ่มคำสั่ง',
    editEmployeeProfile: 'แก้ไขประวัติพนักงาน',
    nameSurname: 'ชื่อ นามสกุล',
    emailAddress: 'อีเมล',
    organization: 'Organization',
    bureau: 'สำนักงาน / หน่วยงาน',
    position: 'ตำแหน่ง',
    startDate: 'วันเริ่มต้น',
    resignDate: 'วันสิ้นสุด',
    msgErrorImageSize: 'ขนาดของรูปภาพต้องอยู่ระหว่าง 25KB เเละ 200KB',
    congratulation: 'ยินดีด้วย',
    updated: 'อัพเดทเรียบร้อย',
    somethingWrong: 'พบข้อผิดพลาด',
    tryAgain: 'กรุณาลองใหม่ภายหลัง',
    lineRegisCode: 'รหัสลงทะเบียน LINE',
    regisCode: 'รหัสลงทะเบียน (Code)',
    instruction: 'คำแนะนำ',
    instructionOne: '1. กรุณาคลิก “สร้างรหัสใหม่” (เฉพาะครั้งแรกเท่านั้น)',
    instructionTwo: '2. คัดลอกรหัสและใส่รหัสนี้ใน Olaf Line OA',
    genNewQrWarning: 'หากคุณต้องการยกเลิกการลงทะเบียน ให้คลิก “สร้างรหัสใหม่” อีกครั้งผู้ใช้ที่มีรหัสก่อนหน้าจะถูกยกเลิกโดยอัตโนมัติ',
    genNewCode: 'สร้างรหัสใหม่',
    setUpLineMenu: 'ตั้งค่าไลน์เมนู',
    selectLineMenu: '- เลือกสิทธิไลน์เมนู -',
    lineAndReportPermission: 'สิทธิการดูข้อมูลในไลน์ & รายงาน',
    selectPermission: '- เลือกข้อมูลแสดง - ',
    selectAll: 'เลือกทั้งหมด',
    deleteEmployee: 'ลบพนักงาน',
    areYouSureToDeleteEmployee: 'คุณแน่ใจหรือว่าต้องการลบพนักงาน',
    employeeIsDeleted: 'พนักงานถูกลบแล้ว',
    exportEployee: 'ดาวน์โหลด Form Excel',
    empRequiredField: 'กรุณากรอกข้อมูล',
    empExceededField: 'ข้อความห้ามเกิน 255 ตัวอักษร',
    emailIsExceeded255Characters: 'อีเมลห้ามเกิน 255 ตัวอักษร',
    invalidEMailFormat: 'รูปแบบอีเมลไม่ถูกต้อง',
    profile: 'ข้อมูล'
}
